function toggleMenu() {
    const flatMenu = document.getElementById('flatMenu');
    const hamburger = document.querySelector('.hamburger');
    if (!flatMenu || !hamburger) return;

    const isOpen = flatMenu.classList.toggle('active');
    hamburger.classList.toggle('active');

    if (isOpen) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = '';
        // Reset all nested menus when the main menu is closed
        document.querySelectorAll('.active').forEach(el => {
            if (el !== flatMenu && el !== hamburger) el.classList.remove('active');
        });
        // Reset all sub-menu wrappers to collapsed state
        if (window.innerWidth <= 960) {
            document.querySelectorAll('.sub-menu-wrapper.active').forEach(wrapper => {
                wrapper.classList.remove('active');
            });
        }
    }
}

function toggleSubmenu(submenuId, element, event) {
    if (window.innerWidth > 960) return false;
    
    // Prevent default if event is provided
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    } else if (window.event) {
        window.event.preventDefault();
        window.event.stopPropagation();
    }
    
    const submenu = document.getElementById(submenuId);
    if (submenu) {
        element.classList.toggle('active');
        submenu.classList.toggle('active');
    }
    return false; // Prevent default and stop propagation
}

/**
 * UNIFIED MOBILE LOGIC
 * Works for .flat-menu-header (Drones/Gimbals) 
 * and .menu-item > a (Accessories, Cameras, Gimbals, etc.)
 */
document.addEventListener('click', function(e) {
    if (window.innerWidth > 960) return;

    // Detect if we clicked a header or a menu link
    const header = e.target.closest('.flat-menu-header');
    const menuLink = e.target.closest('.menu-item > a');

    // Don't interfere with clicks inside dropdowns (unless clicking a header/link)
    if (!header && !menuLink) {
        // If clicking a regular link inside dropdown, allow it
        if (e.target.closest('.dropdown-simple') || e.target.closest('.flat-submenu')) {
            return;
        }
    }

    if (header) {
        // Skip if it has onclick handler (will be handled by toggleSubmenu)
        if (header.hasAttribute('onclick')) {
            // Prevent default navigation, let onclick handle toggle
            e.preventDefault();
            return;
        }
        
        // Logic for flat-menu-header without onclick
        e.preventDefault();
        e.stopPropagation();
        
        const isCurrentlyActive = header.classList.contains('active');
        const submenu = header.nextElementSibling;
        
        // Auto-collapse: Close all other menu items
        if (!isCurrentlyActive) {
            // Close all other flat-menu-headers
            document.querySelectorAll('.flat-menu-header.active').forEach(otherHeader => {
                if (otherHeader !== header) {
                    otherHeader.classList.remove('active');
                    const otherSubmenu = otherHeader.nextElementSibling;
                    if (otherSubmenu && otherSubmenu.classList.contains('flat-submenu')) {
                        otherSubmenu.classList.remove('active');
                    }
                }
            });
            
            // Close all other menu-items
            document.querySelectorAll('.menu-item.active').forEach(otherMenuItem => {
                otherMenuItem.classList.remove('active');
            });
        }
        
        header.classList.toggle('active');
        if (submenu && submenu.classList.contains('flat-submenu')) {
            submenu.classList.toggle('active');
        }
    } 
    else if (menuLink) {
        // Logic for Accessories, Cameras, Gimbals, 3D Printing, Drone Repair, Specials
        // Ignore Enterprise button and flat menu items
        if (menuLink.classList.contains('enterprise-btn')) return;
        
        const parent = menuLink.parentElement;
        if (!parent || !parent.classList.contains('menu-item')) return;
        
        // Skip flat menu items (they don't have dropdowns)
        if (parent.classList.contains('flat-menu-item')) {
            // Allow normal navigation for flat menu items
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        
        const isCurrentlyActive = parent.classList.contains('active');
        
        // Auto-collapse: Close all other menu items
        if (!isCurrentlyActive) {
            // Close all other menu-items
            document.querySelectorAll('.menu-item.active').forEach(otherMenuItem => {
                if (otherMenuItem !== parent) {
                    otherMenuItem.classList.remove('active');
                }
            });
            
            // Close all flat-menu-headers
            document.querySelectorAll('.flat-menu-header.active').forEach(otherHeader => {
                otherHeader.classList.remove('active');
                const otherSubmenu = otherHeader.nextElementSibling;
                if (otherSubmenu && otherSubmenu.classList.contains('flat-submenu')) {
                    otherSubmenu.classList.remove('active');
                }
            });
        }
        
        parent.classList.toggle('active');
        
        // Find the dropdown (simple, mega-menu, or submenu)
        const dropdown = parent.querySelector('.dropdown-simple');
        const megaMenu = parent.querySelector('.mega-menu');
        
        if (dropdown) {
            dropdown.classList.toggle('active');
        }
        // Mega-menu visibility is handled by CSS when .menu-item.active
    }
    
    // Handle sub-menu clicks on mobile - smooth expand/collapse with auto-collapse
    const subMenuLink = e.target.closest('.sub-menu-wrapper > a');
    if (subMenuLink && window.innerWidth <= 960) {
        e.preventDefault();
        e.stopPropagation();
        const subMenuWrapper = subMenuLink.parentElement;
        const isCurrentlyActive = subMenuWrapper.classList.contains('active');
        
        // Auto-collapse: Close all other sub-menus at the same level (same parent)
        if (!isCurrentlyActive) {
            const parentMenu = subMenuWrapper.closest('.menu-item.active, .col');
            if (parentMenu) {
                parentMenu.querySelectorAll('.sub-menu-wrapper.active').forEach(otherWrapper => {
                    if (otherWrapper !== subMenuWrapper) {
                        otherWrapper.classList.remove('active');
                    }
                });
            }
        }
        
        // Toggle active class on wrapper for smooth animation
        subMenuWrapper.classList.toggle('active');
        
        // Ensure sub-menu is accessible
        const subMenu = subMenuWrapper.querySelector('.sub-menu');
        if (subMenu) {
            // Let CSS handle the animation via max-height
            // Just ensure it's in the DOM and accessible
            subMenu.style.display = 'block';
        }
    }
});

window.addEventListener('resize', () => {
    if (window.innerWidth > 960) {
        const flatMenu = document.getElementById('flatMenu');
        const hamburger = document.querySelector('.hamburger');
        if (flatMenu) flatMenu.classList.remove('active');
        if (hamburger) hamburger.classList.remove('active');
        document.body.style.overflow = '';
        document.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
    }
});



/* ===== Task 1: mobile per-category column accordions (single-open) ===== */
(function () {
  function initColHeadings() {
    document.querySelectorAll('.mega-columns .col > h3').forEach(function (h) {
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      if (!h.hasAttribute('aria-expanded')) h.setAttribute('aria-expanded', 'false');
    });
  }
  if (document.readyState !== 'loading') initColHeadings();
  document.addEventListener('DOMContentLoaded', initColHeadings);

  // Toggle a column open/closed; close siblings (single-open). Capture phase so the
  // generic menu handler does not also fire.
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 960) return;
    var h3 = e.target.closest && e.target.closest('.col > h3');
    if (!h3) return;
    if (!h3.closest('.menu-item.active')) return;
    // Only toggle when the tap is in the +/- zone on the right; taps on the title
    // itself follow the link to the collection page.
    var _rect = h3.getBoundingClientRect();
    var _x = (e.clientX != null ? e.clientX : 0);
    if (_x && _x < _rect.right - 52) return;
    e.preventDefault();
    e.stopPropagation();
    var col = h3.parentElement;
    var willOpen = !col.classList.contains('col-open');
    var group = col.closest('.mega-columns');
    if (group) {
      group.querySelectorAll(':scope > .col.col-open').forEach(function (c) {
        if (c !== col) {
          c.classList.remove('col-open');
          var hh = c.querySelector(':scope > h3');
          if (hh) hh.setAttribute('aria-expanded', 'false');
        }
      });
    }
    col.classList.toggle('col-open', willOpen);
    h3.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }, true);

  // Keyboard support (Enter / Space)
  document.addEventListener('keydown', function (e) {
    if (window.innerWidth > 960) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var h3 = e.target.closest && e.target.closest('.col > h3');
    if (!h3 || !h3.closest('.menu-item.active')) return;
    e.preventDefault();
    h3.click();
  });

  // When a top-level accordion is toggled, reset columns to collapsed (clean open state)
  document.addEventListener('click', function (e) {
    if (window.innerWidth > 960) return;
    var top = e.target.closest && e.target.closest('.menu-item > a');
    if (!top || top.classList.contains('enterprise-btn')) return;
    document.querySelectorAll('.mega-columns .col.col-open').forEach(function (c) {
      c.classList.remove('col-open');
      var h = c.querySelector(':scope > h3');
      if (h) h.setAttribute('aria-expanded', 'false');
    });
  });
})();